import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Drawer } from "antd";
import { message } from "../../components/antdMessageBridge";
import { CloseCircleOutlined } from "@ant-design/icons";
import "../manifest_verificationqueue/verification-slider.css";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import CommonObj from "../../CommonObj";
import { useAuth } from "../../auth/AuthContext";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";

const RejectReasonSliderUI = (props) => {
	console.log(props.selectedRecord);

	const [form, setForm] = useState({
		Reason: "",
		statusName: "",
		status: "",
	});
	const { roleUserId } = useAuth();
	const { accessToken } = useAuthToken();
	const [loading, setLoading] = useState(false);
	const [errors] = useState({}); // Kept minimal to prevent ReferenceError in JSX
	const [ierrors, setIErrors] = useState({});
	const [selectedStatus, setSelectedStatus] = useState();
	const [selectedActiveStatus, setselectedActiveStatus] = useState();
	const [rejectReasonData, setRejectReasonData] = useState([]);
	const fetchUserData = async (userId) => {
		setLoading(true);
		const requestData = {
			ID: userId,
			UserId: roleUserId,
		};

		let formData = new FormData();
		Object.keys(requestData).forEach(function (key) {
			formData.append(key, requestData[key]);
		});

		try {
			const myHeaders = {
				Authorization: `Bearer ${accessToken}`,
				"X-CSRF-Token": encryptTimestamp()
			};
			const response = await fetch(CommonObj.Endpoints.GetRejectReasonById, {
				method: "POST",
				headers: myHeaders,
				body: formData,
			});

			if (!response.ok) {
				throw new Error("Network response was not ok");
			}
			const responseText = await response.text();
			let result;

			try {
				result = JSON.parse(responseText);
				setForm({
					Reason: result.rejectReason || "",
					statusName: result.statusName || "",
					status: result.status || "",
				});
				setselectedActiveStatus(result.status);
				
			} catch (e) {
				if (!responseText.includes("No books found.")) {
					throw new Error(responseText || "Failed to parse API response.");
				}
			}
		} catch (err) {
			console.error(err);
		} finally {
			setLoading(false);
		}
	};
	useEffect(() => {
		if (!props.selectedRecord && props.visible) {
			setForm({
				Reason: "",
				statusName: "",
				status: "",
			});
			setselectedActiveStatus(true);
		}
	}, [props.visible, props.selectedRecord]);
	useEffect(() => {
		const fetchMasterData = async () => {
			try {
				const response = await fetch(CommonObj.Endpoints.GetRejectReasons, {
					method: "GET",
					mode: "cors",
					headers: {
						Authorization: `Bearer ${accessToken}`,
						"X-CSRF-Token": encryptTimestamp(),
						"Content-Type": "application/json",
					},
				});


				if (!response.ok) {
					throw new Error(`HTTP error! Status: ${response.status}`);
				}
				const data = await response.json();
				setRejectReasonData(data);
			} catch (error) {
				console.error("Failed to fetch master data:", error);
			}
		};

		fetchMasterData();
	}, []);
	useEffect(() => {
		if (props.selectedRecord && props.visible) {
			fetchUserData(props?.selectedRecord.id);
		}
	}, [props.selectedRecord, props.visible]);

	const handleInternalSubmit = async (e) => {
		e.preventDefault();
		setIErrors({});

		if (!i_validate()) {
			const firstErrorField = Object.keys(ierrors)[0];
			if (firstErrorField) {
				const element = document.getElementById(firstErrorField);
				if (element) element.focus();
			}
			return;
		}
		setLoading(true);
		try {
			const isEdit = !!props.selectedRecord;

			const myHeaders = {
				Authorization: `Bearer ${accessToken}`,
				"X-CSRF-Token": encryptTimestamp()
			};

			const payload = isEdit
				? {
					RejectReason: form.Reason,
					StatusId: form?.statusName,
					ID: props.selectedRecord.id,
					Status: selectedActiveStatus ? 1 : 0,
					UserId: roleUserId,
				}
				: {
					RejectReason: form.Reason,
					StatusId: form.statusName,
					UserId: roleUserId,
				};

			let formData = new FormData();
			Object.entries(payload).forEach(([key, value]) => {
				formData.append(key, value);
			});

			const endpoint = isEdit
				? CommonObj.Endpoints.UpdateRejectReason
				: CommonObj.Endpoints.CreateRejectReason;

			const response = await fetch(endpoint, {
				method: "POST",
				headers: myHeaders,
				body: formData,
			});

			if (!response.ok) throw new Error(`Response status: ${response.status}`);

			const result = await response.json();
			if (result.status === false) {
				const ErrorMsg = result.message !== "" ? result.message : "Failed to save the data";
				message.error(ErrorMsg);
				return;
			}

			if (result.id == "0") {
				const ErrorMsg = "RejectReason already exists.";
				message.error(ErrorMsg);
				return;
			}

			if (result) {
				const successMsg = isEdit
					? "Reject Reason updated successfully."
					: "Reject Reason created successfully.";

				message.success(successMsg);
				handleClear();
				props.onClose();

				if (props.onSuccess) {
					props.onSuccess();
				}
			} else {
				const msg =
					result.message != "" ? result.message : "Failed to save the data";
				message.error(msg);
			}
		} catch (error) {
			message.error("Error submitting form: " + error.message);
		} finally {
			setLoading(false);
		}
	};

	const handleClear = () => {
		if (props.selectedRecord) {
			setselectedActiveStatus(true); // Only clear the checkbox
		} else {
			setForm({
				Reason: "",
				statusName: "",
				status: "",
			});
			setSelectedStatus("");
			setselectedActiveStatus(true);
		}
		setIErrors({});
	};
const handleRejectReasonChange = (e) => {
    const { name, value } = e.target;
    if (ierrors[name]) {
        setIErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[name];
            return newErrors;
        });
    }

	setSelectedStatus(value);
    setForm((prev) => ({
        ...prev,
        [name]: value
    }));
};
	const i_validate = () => {
		const newErrors = {};
		if (!form.Reason || !form.Reason.trim()) {
			newErrors.Reason = "Please Enter Reason";
		}
		if (!form.statusName) {
			newErrors.statusName = "Please Select Activity";
		}

		setIErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const handleInternalChange = (e) => {
		const { name, value } = e.target;
		setForm((prev) => ({ ...prev, [name]: value }));
		if (ierrors[name]) {
			setIErrors((prev) => ({ ...prev, [name]: "" }));
		}
	};

	const handlestatusChange = (e) => {
		setselectedActiveStatus(e.target.checked);
	};

	useEffect(() => {
		if (props.selectedRecord) {
			message.info(props.selectedRecord);
		}
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	const handleClose = () => {
		setIErrors({});
		props.onClose();
	};

	return (
		<Drawer
			title={props.selectedRecord ? "Edit Rejection Reason" : props.title}
			placement={props.placement}
			onClose={handleClose}
			open={props.visible}
			width={props.width}
			className={props.className}
			closeIcon={<CloseCircleOutlined />}
			loading={loading}
		>
			<div className="modal-body">
				<div className="">
					<form
						className="book-page-form"
						onSubmit={handleInternalSubmit}
						noValidate
					>
						<div className="add-user-internal-container">
							<div className="add-user-internal-input-2column">
								{!props.selectedRecord ?
									<div className="field-group">
										<input
											placeholder=""
											id="Reason"
											name="Reason"
											value={form.Reason}
											className={`book-page-form-input-text ${form?.Reason === "" ? "" : "has-text"}`}
											maxLength={100}
											onChange={(e) => {
												const value = e.target.value;
												const filteredValue = value.replace(/[^a-zA-Z0-9 \\,().&'\-\/]/g, '');
												handleInternalChange({ target: { name: 'Reason', value: filteredValue } });
											}}
											required
										/>
										<label htmlFor="Reason" className="label">
											Enter Reason <span className="form-required">*</span>
										</label>
										{ierrors.Reason && (
											<span className="error-msg">
												{ierrors.Reason}
											</span>
										)}
									</div> :
									<div className="field-group">
										<input
											placeholder=""
											id="Reason"
											name="Reason"
											value={form.Reason}
											className={`book-page-form-input-text ${form?.Reason === "" ? "" : "has-text"}`}
											maxLength={100}
											onChange={(e) => {
												const value = e.target.value;
												const filteredValue = value.replace(/[^a-zA-Z0-9 \\,().&'\-\/]/g, '');
												handleInternalChange({ target: { name: 'Reason', value: filteredValue } });
											}}
											required
											disabled
										/>
										<label htmlFor="Reason" className="label">
											Enter Reason <span className="form-required">*</span>
										</label>
										{ierrors.Reason && (
											<span className="error-msg">
												{ierrors.Reason}
											</span>
										)}
									</div> 
									}
								{!props.selectedRecord ?
									<div className="field-group">
										<select
											id="statusName"
											name="statusName"
											className={`book-page-form-input-text ${form?.statusName === "" ? "" : "has-text"}`}
											value={form?.statusName}
											onChange={handleRejectReasonChange}
											required
										>
											<option value="" disabled hidden>
											</option>
											{rejectReasonData.map((reason) => {
												return (
													<option
														key={reason.statusID}
														value={reason.statusID}
													>
														{reason.statusName}
													</option>
												);
											})}
										</select>

										<label htmlFor="statusName" className="label">
											Activity <span className="form-required">*</span>
										</label>
										{ierrors.statusName && (
											<span className="error-msg">{ierrors.statusName}</span>
										)}

								</div> :
								<div className="field-group">
										<select
											id="statusName"
											name="statusName"
											className={`book-page-form-input-text ${form?.statusName === "" ? "" : "has-text"}`}
											value={form.statusName}
											onChange={handleRejectReasonChange}
											required
											disabled
										>
											{rejectReasonData.map((reason) => {
												return (
													<option
														key={reason.statusID}
														value={reason.statusID}
													>
														{reason.statusName}
													</option>
												);
											})}
										</select>

										<label htmlFor="statusName" className="label">
										Activity <span className="form-required">*</span>
									</label>
										{ierrors.statusName && (
											<span className="error-msg">{ierrors.statusName}</span>
									)}

								</div>}
							</div>
							{props?.selectedRecord && (
								<div className="book-page-form-checkbox-button">
									<input
										type="checkbox"
										id="status"
										name="status"
										data-track="reject-reason-master-edit-is-active-toggle"
										onChange={handlestatusChange}
										checked={!!selectedActiveStatus}
									/>
									<label htmlFor="status">
										Is Active
									</label>
									<span className="error-msg">{errors.status}</span>
								</div>
							)}
						</div>
						<div className="modal-footer">
							{!props?.selectedRecord && (
							<button type="button" className="modal-cancel-button" onClick={handleClear}>
								Clear
							</button>
							)}
							<button className="accept-button" data-track="reject-reason-master-submit-reason">Submit</button>
						</div>
					</form>
				</div>
			</div>
		</Drawer>
	);
};

RejectReasonSliderUI.propTypes = {
	selectedRecord: PropTypes.shape({
		ID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	}),
	visible: PropTypes.bool,
	title: PropTypes.string,
	placement: PropTypes.string,
	onClose: PropTypes.func.isRequired,
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	className: PropTypes.string,
	onSuccess: PropTypes.func,
};

export default RejectReasonSliderUI;

